import * as React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, IconButton, Tooltip } from "@material-ui/core";
import * as Guid from "./../../../../common/utils/Guid";
import { getAntiForgeryToken } from "../../../../common/utils/Fetch";
import FilterManagementDialog from "../../../../common/controls/GridHelper/FilterManagementDialog";
import FilterAutocomplete from "../../../../common/controls/GridHelper/FilterAutocomplete";
import { IFilterData } from "../../../../common/controls/GridHelper/FilterData";
import FilterManager, { FilteringGridWrapper } from "../../../../common/controls/GridHelper/FilterManager";
import FilterSaveDialog from "./FilterSaveDialog";

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	filterSelect: {
		flex: '1'
	}
}));

interface Props {
	manageFiltersPermission: boolean,
}

interface State {
	changing: boolean,
	grid?: FilteringGridWrapper,
}

const fnFirst = function (colection, predicate) {
	if (!colection || colection.length == 0)
		return null;

	var len = colection.length,
		index = 0;
	while (index < len) {
		var el = colection[index++];
		if (predicate(el)) {
			return el;
		}
	}
	return null;
};

export default class Filtering extends React.Component<Props, State> {
	constructor(props) {
		super(props);

		this._autoselect = React.createRef<FilterAutocomplete>();
		this.state = {
			changing: false,
			grid: null,
		}
	}

	_autoselect: React.RefObject<FilterAutocomplete>;

	getManager() {
		return new FilterManager(this);
	}

	initGrid(grid: FilteringGridWrapper) {
		this.setState({ grid: grid });

		var qsFilter = decodeURI(window.location.search.substring(1));
		var firstFilter = fnFirst(qsFilter.split('&'), function (f) {
			var gridFilter = f.split('=');
			return gridFilter.length == 1 || (gridFilter.length == 2 /*&& gridFilter[0] === grid.attr('id')*/);
		});

		if (firstFilter) {
			var ff = firstFilter.split('=');
			let filterNameOrExpression = ff[ff.length - 1];
			this._autoselect.current.setFiltersByNameOrExpression(filterNameOrExpression, (data) => {
				if (data == null) {
					grid.fnDraw();
				}
			});
		}
		else {
			var sFilterId = grid.getFilterId();
			if (Guid.isNullOrEmpty(sFilterId)) {
				grid.fnDraw();
			}
			else {
				this.setFilterId(sFilterId);
			}
		}
	}

	setChanging(value: boolean) {
		if (this.state.changing != value)
			this.setState({ changing: value })
	}

	setFilterId(value: string) {
		this._autoselect.current.setValue(value);
	}
	
	handleChangeFilter(filter: IFilterData) {

		let grid = this.state.grid;
		let qdesk = (window as any).qdesk;
		let $ = (window as any).$;
		let columnsFilters = qdesk.columnsFilters;

		var inputs = $('tfoot input.filter, tfoot input[type=checkbox]', grid.grid);
		if (!filter || !filter.TypeName) {
			$.each(inputs, (i, input) => {
				if (input.type == "checkbox") {
					$(input).data('checked', 1); // Status checked = 2
				}
				columnsFilters.applyInputFilter($(input), '');
			});
			grid.setSetting("sFilterId", "");
			grid.setSetting("sFilterName", "");
			grid.setSetting("sFilterPrivacy", false);
			grid.setSetting("sFilterKind", null);

			this.setState({ changing: false });
			return;
		}
		grid.setSetting("sFilterId", filter.Id);


		$.ajax({
			url: "/Filters/GetFilterQueryOptions/",
			dataType: 'json',
			type: 'POST',
			cache: false,
			data: {
				__RequestVerificationToken: getAntiForgeryToken(),
				typeName: filter.TypeName,
				query: filter.Expression
			},
			success: (data) => {
				if (!data)
					return;
				
				var rangeSeparator = grid.getSetting("sRangeSeparator");
				$.each(inputs, function (i, input) {
					var fi = fnFirst(data, function (f) { return f.ColumnName == input.name; });
					var fiExpression = '';
					if (fi) {
						if (input.id.indexOf('range_from_') > -1)
							fiExpression = fi.Literal.split(rangeSeparator)[0];
						else if (input.id.indexOf('range_to_') > -1)
							fiExpression = fi.Literal.split(rangeSeparator)[1];
						else if (input.type == "checkbox") {
							$(input).data('changed', true);
							switch (fi.Literal) {
								case "0":
									fiExpression = 'false'; // Status checked = 0
									$(input).data('checked', 0);
									input.checked = false;
									input.indeterminate = false;
									input.value = '0';
									break;
								case "1":
									fiExpression = 'true'; // Status checked = 1
									$(input).data('checked', 1);
									input.checked = true;
									input.indeterminate = false;
									input.value = '1';
									break;
								default:
									fiExpression = ''; // Status checked = 2
									$(input).data('checked', 2);
									input.checked = true;
									input.indeterminate = true;
									input.value = '';

									break;
							}
						}
						else
							fiExpression = fi.Literal;
					}
					else {
						if (input.type == "checkbox") {
							$(input).data('checked', 2);
							$(input).data('changed', true);
							input.checked = true;
							input.indeterminate = true;
							input.value = '';
						}
					}
					columnsFilters.applyInputFilter($(input), fiExpression);
					
				});
				this.setState({ changing: false });
			}
		});
	}

	loadFilter(filterId: string) {
		if (!filterId)
			return;
	}

	handleOnSaved() {
		this.setChanging(false);
	}

	handleOnChangeProcessState() {
		this.setFilterId(null);
	}

	render() {
		return <FilteringBaner
			grid={this.state.grid}
			changing={this.state.changing}
			manageFiltersPermission={this.props.manageFiltersPermission}
			onChangeFilter={(v) => this.handleChangeFilter(v)}
			onSaved={() => this.handleOnSaved()}
			autoselectRef={this._autoselect}
		/>
	}
}

interface IFilteringBanerProps {
	grid: any,
	changing: boolean,
	manageFiltersPermission: boolean,
	onChangeFilter: (value: IFilterData) => void,
	onSaved: () => void,

	autoselectRef: React.RefObject<FilterAutocomplete>,
}

function FilteringBaner(props: IFilteringBanerProps)
{
	const { t } = useTranslation();
	const classes = useStyles();

	function handleRemove(removedIds: string[]) {
		props.autoselectRef.current.refresh();
	}

	function handleSelect(filterId: string) {
		props.autoselectRef.current.setValue(filterId);
	}

	function handleClearClick() {
		props.autoselectRef.current.setValue(null);
	}

	if (!props.grid)
		return null;

	let value: IFilterData = null;
	if (props.autoselectRef.current)
		value = props.autoselectRef.current.getValue();

	return <div className={classes.root}>
		<FilterAutocomplete
			ref={props.autoselectRef}
			onChange={props.onChangeFilter}
			typeName={props.grid.getFilterTypeName()}
			changing={props.changing}
			className={classes.filterSelect}
			noOptionsMessage={t("control.autocomplete.noOptionsMessage")}
			placeholder={t("control.filtering.selectFilter")}
		/>
		<div>
			<Tooltip title={t("common.action.clear")} placement="bottom">
				<IconButton onClick={handleClearClick} className="iconButton">
					<Icon style={{ fontSize: "20px" }}>clear</Icon>
				</IconButton>
			</Tooltip>
		</div>

		<FilterSaveDialog
			currentFilter={value}
			grid={props.grid}
			onSaved={props.onSaved}
			manageFiltersPermission={props.manageFiltersPermission}
		/>

		<FilterManagementDialog
			onRemove={handleRemove}
			onSelect={handleSelect}
			typeName={props.grid.getFilterTypeName()}
			className=""
		/>
	</div>
}